var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomLeftStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 147,
    viewBox: "0 0 118 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.8 4.905C82.8 7.614 80.604 9.81 77.895 9.81C75.186 9.81 72.99 7.614 72.99 4.905C72.99 2.196 75.186 0 77.895 0C80.604 0 82.8 2.196 82.8 4.905Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07602 42.896C6.07602 44.574 4.71602 45.934 3.03802 45.934C1.36002 45.934 0 44.574 0 42.896C0 41.218 1.36002 39.858 3.03802 39.858C4.71502 39.858 6.07602 41.218 6.07602 42.896Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.155 42.896C117.155 44.574 115.795 45.934 114.117 45.934C112.439 45.934 111.079 44.574 111.079 42.896C111.079 41.218 112.439 39.858 114.117 39.858C115.794 39.858 117.155 41.218 117.155 42.896Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.32 146.587C88.9978 146.587 90.358 145.227 90.358 143.549C90.358 141.871 88.9978 140.511 87.32 140.511C85.6421 140.511 84.282 141.871 84.282 143.549C84.282 145.227 85.6421 146.587 87.32 146.587Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.92 120.24C25.821 125.845 30.216 130.239 35.82 131.14C30.215 132.041 25.821 136.436 24.92 142.04C24.019 136.435 19.624 132.041 14.02 131.14C19.625 130.239 24.019 125.844 24.92 120.24Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftStars);
export default __webpack_public_path__ + "static/media/bottom-left-stars.bbbcf247fc6d6f0c44bd10fe2bca3836.svg";
export { ForwardRef as ReactComponent };